import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    question: 'What do I have to send you?',
    answer: 'Your website address. That is it. We do the rest and send you back a redesign of it.',
  },
  {
    question: 'Do I have to commit to anything first?',
    answer: 'No. You see the finished thing before any of that comes up. If it is not right, you have lost nothing and we will say so ourselves if we do not think it is worth doing.',
  },
  {
    question: 'Is it a mockup or a real site?',
    answer: 'A real one, built and live, so you can open it on your phone and click through it.',
  },
  {
    question: 'What if I like my website and just want to be found?',
    answer: 'Then we do that part on its own, on the site you already have, and leave the design alone. It is the smaller job. A redesign is for a site that has fallen behind the work and needs rebuilding, and every redesign has the getting found work inside it as standard.',
  },
  {
    question: 'Who do you work with?',
    answer: 'Businesses where one enquiry is worth a lot, so being overlooked actually costs money: private aviation, charter, villas and private houses, hotels, travel companies, advisory firms, design studios, manufacturers and private clubs. The industry matters less than that. We are not a fit for anyone who wants a template site at the lowest price, and we will say so early rather than waste your time.',
  },
  {
    question: 'What does it cost and what do I own?',
    answer: 'Priced by quote, because a one-page site and a ten-service business are not the same job. You own everything: the design, the code, the words, the data, on your own domain.',
  },
  {
    question: 'How long does it take?',
    answer: 'Live within a few weeks of you approving a direction, and we give you a date rather than a range. We take a small number of these at a time, so if we are full we will tell you.',
  },
];

export default function FAQPremium() {
  return (
    <section className="bg-[#F8F4EC] py-16 sm:py-24 lg:py-28 border-t border-[#1A1814]/10" aria-label="Frequently Asked Questions">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 md:px-12 lg:px-16">
        <div className="flex items-center gap-4 text-[12px] sm:text-[13px] tracking-[0.32em] uppercase text-[#C5A059] font-semibold mb-12 sm:mb-16">
          <span aria-hidden className="block w-10 h-px bg-[#C5A059]/60" />
          Questions
        </div>
        <div className="mb-12 sm:mb-16">
          <h2
            className="font-display text-[#1A1814] max-w-[20ch]"
            style={{
              fontSize: 'clamp(36px, 5.5vw, 68px)',
              lineHeight: 1.02,
              letterSpacing: '-0.028em',
              textWrap: 'balance',
            }}
          >
            What everyone <span style={{ color: '#C5A059' }}>asks us first.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="border-t border-[#1A1814]/15">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-[#1A1814]/15"
            >
              <AccordionTrigger
                className="text-left text-[#1A1814] hover:text-[#C5A059] transition-colors py-6 sm:py-7"
              >
                <span
                  className="font-display"
                  style={{ fontSize: 'clamp(20px, 2.4vw, 26px)', lineHeight: 1.25, letterSpacing: '-0.005em' }}
                >
                  {faq.question}
                </span>
              </AccordionTrigger>
              <AccordionContent
                className="text-[#3F3A30] pb-7 pr-4"
                style={{ fontSize: 'clamp(17px, 1.8vw, 19px)', lineHeight: 1.6 }}
              >
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
